/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
// tslint:disable
import { AsyncResult, callActionOrExecute, DataServiceQuery, IContext, IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
// @ts-ignore
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
import * as DataServiceEntities from './DataServiceEntities.g';

// @ts-ignore
function vSIGetAPIResponseQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery('VSIGetRestAPIResponse', 'VSIRestAPIHandler', DataServiceEntities.VSIRestAPIHandlerExtensionClass, key);
}

export function createVSIInitiateRestCallInput(
    targetSystem: string,
    methodType: string,
    requestHeader: string,
    requestBody: string,
    urlParams: string,
    servicePath: string
): IDataServiceRequest {
    const query = vSIGetAPIResponseQuery();
    return query.createDataServiceRequestForOperation(
        'VSI_CallGenericRestAPIHandler',
        true,
        DataServiceEntities.VSIRestAPIHandlerExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IVSIRestAPIHandler' },
        {
            targetSystem: targetSystem,
            methodType: methodType,
            requestHeader: requestHeader,
            requestBody: requestBody,
            urlParams: urlParams,
            servicePath: servicePath
        }
    );
}

export function vSIInitiateRestCallAsync(
    context: IContext,
    targetSystem: string,
    methodType: string,
    requestHeader: string,
    requestBody: string,
    urlParams: string,
    servicePath: string
): AsyncResult<DataServiceEntities.IVSIRestAPIHandler> {
    const request = createVSIInitiateRestCallInput(targetSystem, methodType, requestHeader, requestBody, urlParams, servicePath);
    return callActionOrExecute<DataServiceEntities.IVSIRestAPIHandler>(request, context.callerContext);
}
